import { render, staticRenderFns } from "./mapTab.vue?vue&type=template&id=2ff7e936&scoped=true&"
import script from "./mapTab.vue?vue&type=script&lang=js&"
export * from "./mapTab.vue?vue&type=script&lang=js&"
import style0 from "./mapTab.vue?vue&type=style&index=0&id=2ff7e936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff7e936",
  null
  
)

export default component.exports